import { Link, useSearchParams } from "react-router-dom";
import { useEffect } from "react";
import { ArrowLeft, Lock } from "lucide-react";
import { useAuth } from "@/lib/auth";

const REDIRECT_URL = `${window.location.origin}/admin/profile`;
const EMERGENT_AUTH_URL = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(REDIRECT_URL)}`;

export default function AdminLogin() {
  const { user, loading } = useAuth();
  const [params] = useSearchParams();
  const error = params.get("error");

  useEffect(() => {
    if (!loading && user?.is_admin) {
      window.location.href = "/admin";
    }
  }, [user, loading]);

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white flex flex-col">
      <header className="px-6 sm:px-10 py-6 border-b border-white/10">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-[#A3A3A3] hover:text-white" data-testid="login-back">
          <ArrowLeft className="w-4 h-4" /> Back to site
        </Link>
      </header>
      <main className="flex-1 flex items-center justify-center px-6">
        <div className="w-full max-w-md text-center">
          <div className="text-[10px] uppercase tracking-[0.3em] font-bold text-[#D92D20] mb-4">
            Admin access
          </div>
          <h1 className="font-display font-black tracking-tighter text-5xl leading-[0.95]">
            Sign in.
          </h1>
          <p className="mt-6 text-[#A3A3A3] leading-relaxed">
            The admin dashboard is restricted to authorized Google accounts only.
          </p>

          <a
            href={EMERGENT_AUTH_URL}
            className="mt-10 inline-flex items-center gap-3 bg-white text-[#0A0A0A] px-7 py-4 font-medium hover:bg-[#D92D20] hover:text-white transition-colors"
            data-testid="google-signin-btn"
          >
            <Lock className="w-4 h-4" /> Sign in with Google
          </a>

          {error && (
            <div className="mt-8 text-sm text-[#D92D20]" data-testid="login-error">
              {error === "missing_session" && "Sign-in was cancelled or the link expired. Try again."}
              {error === "auth_failed" && "Sign-in failed. Try again."}
              {!["missing_session", "auth_failed"].includes(error) && error}
            </div>
          )}

          <p className="mt-12 text-[10px] uppercase tracking-[0.2em] text-[#525252]">
            Authorized accounts only · Anyone else will be denied
          </p>
        </div>
      </main>
    </div>
  );
}
